// @generated by TypeGen from LogbookModel/DataRecord.swift - DO NOT EDIT

import type { ILogbookModel } from "./Model"

export interface IDataRecord extends ILogbookModel {
  id: number;
  cruiseId?: number;
  tripId?: number;
  dayId?: number;
  logId?: number;
  statusId?: number;
  parentId?: number;
  accountId: number;
  shipId: number;
  userId?: number;
  createdAt: string;
  updatedAt: string;
  syncedAt?: string;
  deletedAt?: string;
  recordedAt: string;
  category: IDataRecordCategory;
  type?: IDataRecordType;
  shipDataId?: string;
  sortOrder?: number;
  nmeaNumber?: number;
  source?: IDataRecordSource;
  name?: string;
  data: string;
}

export interface IDataRecordResponse {
  dataRecord?: IDataRecord;
}

export interface IDataRecordsResponse {
  dataRecords: IDataRecord[];
}

export enum IDataRecordCategory {
  test = "test",
  generator = "generator",
  dataTransition = "dataTransition",
}

export enum IDataRecordSource {
  manual = 1,
  n2k = 2,
  imported = 3,
  simulator = 4,
}

export enum IDataRecordType {
  state = "state",
  reading = "reading",
}
